import { useContext } from 'react';
import { ContextUserProfile } from '../contexts/UserProfileContext';

const useUserProfile = () => {
    return useContext(ContextUserProfile);
};

export default useUserProfile;
